module.exports = __webpack_public_path__ + "img/HR52508873833.a96f379e.png";